import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--delete-verification"
// Gates a delete form submit behind a typed confirmation string, mirroring the
// @a-safe-digital React DeleteModal `verificationText` behaviour. The controller
// lives on the <dialog> (alongside ui--modal) so it can see both the input in the
// modal body and the delete <form> in the footer, whose `submit` event bubbles up.
//
// Per the project rule "No disabled submit buttons", the confirm button stays
// clickable — an incorrect entry is rejected at submit with an inline error.
export default class extends Controller {
  static targets = ["input", "error"]
  static values = {
    text: String,
    error: { type: String, default: "Invalid verification text" },
  }

  // Bound to the dialog's `submit` (bubbles from the delete button_to form).
  validate(event) {
    if (!this.hasTextValue || this.textValue.trim() === "") return

    const typed = this.hasInputTarget ? this.inputTarget.value.trim() : ""
    if (typed !== this.textValue.trim()) {
      event.preventDefault()
      this.#showError()
    }
  }

  clearError() {
    this.#hideError()
  }

  #showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = this.errorValue
      this.errorTarget.classList.remove("hidden")
    }
    // The bordered container is the input's parent (see Ui::InputComponent).
    this.inputTarget?.parentElement?.classList.add("border-danger!")
    this.inputTarget?.setAttribute("aria-invalid", "true")
    this.inputTarget?.focus()
  }

  #hideError() {
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
    this.inputTarget?.parentElement?.classList.remove("border-danger!")
    this.inputTarget?.removeAttribute("aria-invalid")
  }
}
